<template>
	<ul class="CNl7QD1FpnStvA1noMH8" :class="$store.state.config.ui_version=='3.1'?'CNl7QD1FpnStvA1noMH8Sandian1':''">
		<li v-for="(item,index) in sidebarsList" class="sidebars-List" :key="index" v-if="item.isShow">
			<van-swipe class="my-swipe" :autoplay="3000" indicator-color="white" :show-indicators="false">
				<van-swipe-item @click="openUrl(item_sy)" v-if="item_sy!==true" v-for="(item_sy,index1) in item"
					:key="index1">
					<img v-lazy="item_sy.image" class="im" alt="">
				</van-swipe-item>
			</van-swipe>
			<p class="KXUP_IukrjksI9v7ohfA" @click="item.isShow=false">
				<img v-if="$store.state.config.ui_version=='3.1'" style="width: .3rem;margin-top: .1rem;" v-lazy="fanhuisems"  alt="">
				<svg-icon v-else className="svg" icon-class="comm_icon_x--svgSprite:all" />
			</p>
		</li>
		<li @click="homeScrollbar" class="menmes" style="padding-top: .1rem;" v-if="$store.state.Returntotop">
			<div class="LgFw5l227MkKBKpLD64g float-bar">
				<div>
					<div class="GO6MyZdeydW4ZcSgnvkK float-bar__icon-wrap">
						<svg-icon className="svg" icon-class="comm_icon_fhdb--svgSprite:all" />
					</div>
					<div v-if="$store.state.config.ui_version=='3.1'" class="oBV4WKCvUQyDmGdMy1nT float-bar__title" >TOPO</div>
					<div class="oBV4WKCvUQyDmGdMy1nT float-bar__title" v-else>{{$t('components._Topo')}}</div>
				</div>
			</div>
		</li>
		<li @click="homeScrollbar" class="menmes3_7" style="padding-top: .1rem;" v-if="$store.state.Returntotop">
			<div class="LgFw5l227MkKBKpLD64g float-bar" :style="{
				'background-image': `url(${aoarrnimym})`
			}">
				<!-- a0he3-tgjjt.png -->
				<!-- aoarrnimym -->
				<div>
					<img :src="fanhuis" alt="" style="width: .27rem;height: .4rem;margin: 0 auto;display: block;" sizes="" srcset="" />
					<div v-if="$store.state.config.ui_version=='3.1'" class="oBV4WKCvUQyDmGdMy1nT float-bar__title" >TOPO</div>
					<div v-else class="oBV4WKCvUQyDmGdMy1nT float-bar__title">{{$t('components._TOPO_1')}}1</div>
					
				</div>
			</div>
		</li>
	</ul>
</template>

<script>
	export default {
		props: {
			sidebarsList: {
				type: [Object, Array],
				required: {},
			}
		},
		data() {
			return {
				codeValue: '',
				aoarrnimym: require('./../../assets/4Ddian/a0he3-tgjjt.png'),
				fanhuis: require('./../../assets/4Ddian/akk9s-l4d85.png'),
				fanhuisems: require('./../../assets/a83cu-6jp7l.png'),
				inputFocus: false,
			};
		},
		mounted(){
		},
		methods: {
			homeScrollbar(){
				this.homeScrollbarDom.scrollTo({
					top: 0,
					behavior: 'smooth' // 平滑滚动效果
				  })
			},
			handleScroll(e){
				console.log(e);
			},
			openUrl(e) {
				if(e.isJumpUrl){
					window.open(e.jump_url, '_blank');
				}else if (e.jump_url && e.jump_url != '#') {
					// 跳转富文本
					if(e.jump_url == 'richText') {
						this.$router.push({name:'details',query:{
							title:e.title,
							content:e.content,
						}})
						return;
					}
					if(/^http/.test(e.jump_url)){
						window.open(e.jump_url, '_blank');
						return false;
					}
					this.$router.push({name:e.jump_url})
				}
			}
		},
	}
</script>

<style scoped>
		.CNl7QD1FpnStvA1noMH8Sandian1 .sidebars-List,.CNl7QD1FpnStvA1noMH8Sandian1 .sidebars-List .im {
			width: 1.0884rem !important;
			height: 1.0884rem !important;
		}
		.CNl7QD1FpnStvA1noMH8Sandian1 .LgFw5l227MkKBKpLD64g{
			margin-left:.1rem;
			opacity: .9;
		}
		
		.csapp37 .LgFw5l227MkKBKpLD64g{
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: transparent;
			border: none;
		}
		.csapp37 .LgFw5l227MkKBKpLD64g{
			width: .9rem;
			    height: .84rem;
				max-height: .84rem;
				min-height:auto !important;
				box-sizing: border-box;
				max-width: .9rem;
		}
		.csapp37 .oBV4WKCvUQyDmGdMy1nT{
			color: var(--skin__text_primary ) !important;
		}
	.LgFw5l227MkKBKpLD64g {
	    background-color: var(--theme-main-bg-color);
	    border: .01rem solid var(--theme-color-line);
		background-size: 100% 100%;
	    border-radius: .1rem;
	    -webkit-box-shadow: .02rem 0 .06rem 0 rgba(0,0,0,.1);
	    box-shadow: .02rem 0 .06rem 0 rgba(0,0,0,.1);
	    cursor: pointer;
	    -ms-flex-direction: column;
	    flex-direction: column;
	    min-height: .78rem;
	    padding: .1rem;
	    width: .84rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	 .LgFw5l227MkKBKpLD64g {
	    min-height: 1rem;
	    padding: .14rem .1rem;
		box-sizing: border-box;
	    width: 1.1rem;
		margin-left: .5rem;
	}
	
	.GO6MyZdeydW4ZcSgnvkK {
	    height: .38rem;
	    width: .38rem;
		margin: 0 auto;
	}
	.GO6MyZdeydW4ZcSgnvkK {
	    background-color: var(--theme-primary-color);
	    border-radius: 50%;
	    color: var(--theme-primary-font-color);
	    font-size: .2rem;
		display: flex;
		align-items: center;
		justify-content: center;
	    margin-bottom: .08rem;
	}
	.oBV4WKCvUQyDmGdMy1nT {
	    word-wrap: break-word;
	    -webkit-line-clamp: 2;
		font-size: .2rem;
	    -webkit-box-orient: vertical;
	    color: var(--theme-text-color-lighten);
	    display: -webkit-box;
	    font-size: .18rem;
	    overflow: hidden;
	    text-align: center;
	    text-overflow: ellipsis;
	    vertical-align: middle;
	    width: 100%
	}
	.GO6MyZdeydW4ZcSgnvkK svg{
		width: .2rem;
		height: .2rem;
	}
	.CNl7QD1FpnStvA1noMH8 {
		position: absolute;
		bottom: 1.31rem;
		z-index: 99;
		right: .1rem;
	}

	.CNl7QD1FpnStvA1noMH8 .sidebars-List {
		width: 1.5rem;
		height: 1.5rem;
		position: relative;
		margin-top: .2rem;
	}

	.CNl7QD1FpnStvA1noMH8 .sidebars-List .im {
		width: 1.5rem;
		height: 1.5rem;
	}

	.KXUP_IukrjksI9v7ohfA {
		-ms-flex-align: center;
		-ms-flex-pack: center;
		align-items: center;
		border: .01rem solid var(--theme-text-color-lighten);
		border-radius: 50%;
		display: -ms-flexbox;
		display: flex;
		height: .2rem;
		justify-content: center;
		position: absolute;
		right: 0;
		z-index: 9999;
		top: 0;
		width: .2rem;
	}

	.KXUP_IukrjksI9v7ohfA .svg {
		color: var(--theme-text-color-lighten);
		height: .08rem;
		width: .08rem;
	}
	.menmes3_7{
		display: none;
	}
	.csapp37 .menmes{
		display: none;
	}
	.csapp37 .menmes3_7{
		display: block;
	}
</style>
